<template>
    <div>
        <b-row>
            <!-- SHOW ALWAYS -->
            <b-col md="12">
                <b-form-group>
                    <span><strong>Show always</strong></span>
                    <b-form-checkbox name="showAlways" class="float-right" switch stacked v-model="selectedValueShowAlwaysButton" />
                </b-form-group>
            </b-col>

            <!-- twoStepPopupDisplay -->
            <b-col md="12">
                <b-form-group>
                    <label for="modalDisplay">
                        <h6><strong>When does it display?</strong></h6>
                    </label>
                    <Select2 name="modalDisplay" :options="barDisplayOptions" v-model="selectedValues.modalDisplay" />
                </b-form-group>
            </b-col>
        </b-row>
    </div>
</template>

<script>
    import { BRow, BCol, BFormInput, BFormGroup, BFormCheckbox, BFormSelect } from 'bootstrap-vue'
    import Ripple from 'vue-ripple-directive'
    import captureOptions from "@/libs/capture-Options"

    export default {
        directives: {
            Ripple
        },
        components: {
            BRow, BCol, BFormInput, BFormGroup, BFormCheckbox, BFormSelect,
        },
        name: 'TwoStepPopupSetting',
        data() {
            return {}
        },
        props: {
            prop_siteSettingArray: {
                type: Object,
                default: () => { },
            }
        },
        setup() {
            const { barDisplayOptions } = captureOptions();
            return {
                barDisplayOptions
            }
        },
        computed: {
            selectedValues() {
                if (this.prop_siteSettingArray) {
                    return this.prop_siteSettingArray;
                } else {
                    return [];
                }
            },

            selectedValueShowAlwaysButton: {
                get() {
                    return this.selectedValues.showAlways == 1 ? true : false;
                },
                set(newValue) {
                    this.selectedValues.showAlways = newValue == true ? 1 : 0;
                }
            },
        },
        created() {
            if (_.isEmpty(this.prop_siteSettingArray.modalDisplay) || this.prop_siteSettingArray.modalDisplay == 0) {
                this.prop_siteSettingArray.modalDisplay = '1';
            }
        },
    }
</script>
